export default "__VITE_PUBLIC_ASSET__9be3a3a5__"